import React from 'react'

const About = (props) => {
	return (
		<div className="full-screen" onClick={props.onClick} >
				<div className="container about">
					<div className="card card-colored shadow">
						<h1 className="h1">Testi<span className="text-small"><br /> by Tim Kmecl</span></h1>
						<hr />
						<ul>
							<li>Facebook: <a href="https://facebook.com/tim.kmecl" target="_blank" >Tim Kmecl</a></li>
							<li>Email <a href="mailto:tim.kmecl.tk@gmail.com">tim.kmecl.tk@gmail.com</a></li>
						</ul>
					</div>
				</div>
			</div>
	)
}

export default About
